<template>
    <div id="estimatorComponent">

        <b-modal no-close-on-backdrop no-close-on-esc centered hide-header hide-footer size="sm" body-class="align-items-center d-flex justify-content-around" v-model="showSpinner"><b-spinner></b-spinner> <span>Processing your input ...</span></b-modal>

        <b-row>
            <b-col>
                <div class="float-left">
                    <h4 style="font-size: 28px; margin-top: 0px;">For more information please contact<br /></h4>
                    <p class="mt-2 contact">
                        <b-col class="row">
                            <b-row>
                                <b-col><b-link style="color:#000" :href="href">{{ contactEmail }}</b-link></b-col>
                                <div class="w-100"></div>
                                <b-col style="color: #EA7600">{{ contactPhone }}</b-col>
                                <div class="w-100"></div>
                                <b-col>
                                    <br /><b-link style="color:#000" href="https://www.epiqglobal.com/en-au" target="_blank">Epiq (epiqglobal.com)</b-link>
                                    <br /><b-link style="color:#000" href="https://www.epiqglobal.com/en-au/terms-of-use-au" target="_blank">Terms of Use</b-link>
                                </b-col>
                            </b-row>

                        </b-col>

                    </p>
                </div>
            </b-col>

            <b-col>
                <div class="w-100" style="border: 1px solid #DF4957; background-color: #FFC1CC; color: black; border-radius: 5px; " v-if="showAlertPanel">
                    <p class="p-3 m-0" v-if="messageToDisplay == 1">
                        Minimum estimate quantity: 15 minutes<br />
                        Either use minute or hour selection or both.
                    </p>
                    <p class="p-3 m-0" v-if="messageToDisplay == 2">
                        Maximum hour quantity: 10000
                    </p>
                </div>

                <div class="w-100 m-0 p-0" style="border: 1px solid #808080; background-color: #CCC; color: black; border-radius: 5px; " v-if="!showAlertPanel">
                    <p class="p-3 m-0">
                        Minimum estimate quantity: 15 minutes
                    </p>
                </div>

                <b-form-group label="Total estimated audio duration" class="mt-3" label-for="duration" label-cols-md="6">

                    <div class="position-relative">
                        <b-input-group class="mb-1">
                            <template #append>
                                <b-input-group-text style="width:90px;">hours</b-input-group-text>
                            </template>
                            <b-form-input name="estiamtedHours"
                                          v-model="estimatedDurationHours"
                                          min="0"
                                          max="1000"
                                          @keydown.native="validateInteger"
                                          :readonly="quoteReceived">
                            </b-form-input>
                        </b-input-group>
                    </div>

                    <div class="position-relative">
                        <b-input-group class="mb-1">
                            <template #append> 
                                <b-input-group-text style="width:90px;">minutes</b-input-group-text>
                            </template>
                            <b-form-select name="estiamtedHours"
                                           v-model="estimatedDurationMinutes"
                                           :options="minuteOptions"
                                           :disabled="quoteReceived">
                            </b-form-select>
                        </b-input-group>
                    </div>

                </b-form-group>

                <validation-observer v-slot="{ handleSubmit }" slim>

                    <validation-provider ref="serviceTypeValidationProvider" rules="required" name="Service Type" v-slot="{ errors }" slim mode="passive">
                        <b-form-group class="position-relative" label-for="serviceTypeSelect" label="Service Type">
                            <select2 ref="serviceTypeSelect"
                                     name="serviceTypeSelect"
                                     key="serviceTypeSelect"
                                     placeholder="Select a Service Type"
                                     :options="serviceTypes"
                                     key-property="serviceTypeId"
                                     text-property="name"
                                     disable-search
                                     allow-clear
                                     :state="errors[0] ? false : null"
                                     v-model="serviceTypeId"
                                     v-on:select="serviceTypeSelectionChanged"
                                     :disabled="quoteReceived"></select2>
                            <b-form-invalid-feedback class="invalid-tooltip">{{ errors[0] }}</b-form-invalid-feedback>
                        </b-form-group>
                    </validation-provider>

                    <template v-if="selectedServiceType && selectedServiceType.requiresServiceDelay">
                        <validation-provider ref="serviceDelayValidationProvider" rules="required" name="Turnaround" v-slot="{ errors }" slim mode="passive">
                            <b-form-group class="position-relative" label-for="serviceDelaySelect" label="Turnaround">
                                <select2 name="serviceDelaySelect"
                                         key="serviceDelaySelect"
                                         placeholder="Select a turnaround"
                                         :options="serviceDelays"
                                         key-property="serviceDelayId"
                                         text-property="name"
                                         disable-search
                                         allow-clear
                                         :disabled="quoteReceived"
                                         :state="errors[0] ? false : null"
                                         v-model="serviceDelayId"
                                         v-on:select="serviceDelaySelectionChanged"></select2>
                                <b-form-invalid-feedback class="invalid-tooltip">{{ errors[0] }}</b-form-invalid-feedback>
                            </b-form-group>
                        </validation-provider>
                    </template>

                    <div class="clearfix">
                        <b-button class="float-left" variant="info" @click="startOverAgain">Clear</b-button> <!--- :disabled="!quoteReceived" -->

                        <b-button class="float-right" variant="success" @click="handleSubmit(requestQuote);" :disabled="quoteReceived">Estimate</b-button>
                    </div>

                    <div v-if="quoteReceived" class="result-div">
                        <div>
                            <h4>Estimated amount excl. {{ $t("Shared.Label.GST") }}: {{  calculatedTotalAmount }}</h4>

                            <p>Reference Number: {{ quoteReferenceNumber }}</p>
                            <p class="small">
                                1. We endeavour to estimate as accurately as possible however please note the final invoiced amount may differ<br />
                                2. The provided estimate is the total cost for 1 single ordering party, if parties agree, the final invoice total amount will be split accordingly<br />
                                3. A minimum charge of $110.00 per hearing, per day, per party will be charged plus any applicable surcharges<br />
                                4. Turnaround times are based on business day
                            </p>
                        </div>
                    </div>

                </validation-observer>
            </b-col>

            <b-col>
                <div class="rightCol">
                    xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
                </div>
            </b-col>

        </b-row>
    </div>
</template>

<script>

    import Vue from 'vue';
    import { BootstrapVue } from 'bootstrap-vue'
    import axios from 'axios';

    import { ValidationProvider, ValidationObserver } from 'vee-validate';
    import { extend, localize } from 'vee-validate';
    import { required, integer, between } from 'vee-validate/dist/rules';
    import en from 'vee-validate/dist/locale/en.json';
    extend('required', required);
    extend('integer', integer);
    extend('between', between);

    localize('en', en);

    import ErrorsMixin from '../mixins/ErrorsMixin';
    import DateTimeMixin from '../mixins/DateTimeMixin';
    import Select2 from './Select2';

    Vue.use(BootstrapVue);

    Vue.use(DateTimeMixin);
    Vue.component('validation-provider', ValidationProvider);
    Vue.component('validation-observer', ValidationObserver);

    Vue.component('select2', Select2);

    export default {
        name: 'QuoteNew',
        mixins: [ErrorsMixin, DateTimeMixin],
        props: {
            baseUrl: {
                type: String,
                required: true
            },
            apiBaseUrl: {
                type: String,
                required: true
            },
            courtRegistryId: {
                type: String,
                default: 'aaa04cce-7dcb-4899-79cb-08d8603b8f96'// Queensland Court
            },
            contactPhone: {
                type: String,
                default: '07 3520 0399'
            },
            contactEmail: {
                type: String,
                default: 'australia@epiqglobal.com'
            }
        },
        data: function () {
            return {
                showSpinner: false,
                tags: true,
                multiple: true,
                maximumSelectionLength: 1,

                showAlertPanel: false,
                messageToDisplay: 0,

                //estimatedDuration: null,
                estimatedDurationHours: 0,
                hourOptions: [
                    { value: 1, text: '1' },
                    { value: 2, text: '2' },
                    { value: 3, text: '3' },
                    { value: 4, text: '4' },
                    { value: 5, text: '5' },
                    { value: 6, text: '6' },
                    { value: 7, text: '7' },
                    { value: 8, text: '8' },
                    { value: 9, text: '9' },
                    { value: 10, text: '10' },
                ],

                estimatedDurationMinutes: 0,
                minuteOptions: [
                    { value: 0, text: '0' },
                    { value: 15, text: '15' },
                    { value: 30, text: '30' },
                    { value: 45, text: '45' }
                ],

                serviceTypes: null,
                selectedServiceType: null,
                serviceTypeId: null,

                serviceDelays: null,
                serviceDelayId: null,

                quoteReceived: false,
                calculatedTotalAmount: 0,
                quoteReferenceNumber: null,

                href: "mailto:" + this.contactEmail + "?subject=Quick Transcription Estimator",
            }
        },

        methods: {

            validateInteger: function (event) {
                const keyCode = event.keyCode;
                // (0..9 on keyboard) || (0..9 on numpad) || backspace || tab)
                if (!((keyCode >= 48 && keyCode <= 57) || (keyCode >= 96 && keyCode<= 105) || keyCode == 8 || keyCode == 9)) event.preventDefault();
            },

            getImageUrl: function () {
                return this.baseUrl + 'images/transcriber-girl-medium.png';
            },

            loadServiceTypes: function () {

                if (this.courtRegistryId != null) {

                    var todaysDate = new Date();
                    var url = this.apiBaseUrl + "/Quote/servicetypes/bycourtregistry/" + this.courtRegistryId + "/";
                    url += this.formatDateTime(todaysDate, 'YYYY-MM-DD', true, true) + "/";

                    this.showSpinner = true;

                    axios
                        .get(url)
                        .then(response => {
                            this.serviceTypes = response.data;
                            this.showSpinner = false;
                        })
                        .catch(ex => {
                            var currentErrors = this.handleAxiosException(ex);
                            this.showSpinner = false;
                            this.showErrorsToast(currentErrors);
                        })
                        .finally(() => {
                          
                        });
                }
            },

            serviceTypeSelectionChanged: function () {
                if (this.serviceTypeId) {
                    // 2 lines josef
                    this.$refs.serviceTypeValidationProvider.reset();
                    //this.$refs.serviceDelayValidationProvider.reset();
                    this.selectedServiceType = this.$refs.serviceTypeSelect.getSelectedData();

                    if (this.selectedServiceType && this.selectedServiceType.length) this.selectedServiceType = this.selectedServiceType[0];
                } else {
                    this.selectedServiceType = null;
                }
                this.loadServiceDelays();
            },

            serviceDelaySelectionChanged: function () {
                this.$refs.serviceDelayValidationProvider.reset();
            },

            loadServiceDelays: function () {
                this.serviceDelays = null;
                this.serviceDelayId = null;
                if ((this.courtRegistryId != null) && (this.selectedServiceType != null) && (this.selectedServiceType.requiresServiceDelay)) {

                    var url = this.apiBaseUrl;
                    if (!url.endsWith('/')) url += '/';

                    url += "Quote/servicedelays/bycourtregistry/";
                    url += this.courtRegistryId;
                    url += "/" + this.formatDateTime(new Date(), 'YYYY-MM-DD', false, false) + "/" + this.serviceTypeId;

                    this.showSpinner = true;
                    axios
                        .get(url)
                        .then(response => {
                            this.serviceDelays = response.data;
                            this.showSpinner = false;
                        })
                        .catch(ex => {
                            var currentErrors = this.handleAxiosException(ex);
                            this.showSpinner = false;
                            this.showErrorsToast(currentErrors);
                        });
                }
            },

            requestQuote: function () {

                var data = {

                    courtRegistryId: this.courtRegistryId, // QLD Court is passed in for now
                    serviceTypeId: this.serviceTypeId,
                    serviceDelayId: this.serviceDelayId,
                    estimatedDurationMinutes: this.estimatedDurationMinutes,
                    estimatedDurationHours: this.estimatedDurationHours
                };

                // check if not both values (min, hours) are 0
                if (!this.estimatedDurationMinutes && !this.estimatedDurationHours) {
                    this.showAlertPanel = true;
                    this.messageToDisplay = 1;
                    return;
                }
                // check if hours exceed 10000
                if (this.estimatedDurationHours > 10000) {
                    this.showAlertPanel = true;
                    this.messageToDisplay = 2;
                    return;
                }

                this.showAlertPanel = false;
                this.messageToDisplay = 0;

                var url = this.apiBaseUrl;
                if (!url.endsWith('/')) url += '/';
                url += "quote/requestsimple";
                this.showSpinner = true;
                axios
                    .post(url, JSON.stringify(data),
                        {
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        })
                    .then(response => {
                        var quote = response.data;
                        this.calculatedTotalAmount = quote.calculatedTotalAmount.toLocaleString('en-AU', { style: 'currency', currency: 'AUD' });

                        this.quoteReferenceNumber = quote.quoteNumberDisplayText;
                        this.quoteReceived = true;

                        this.showSpinner = false;
                        this.$bvToast.toast('Estimate received successfully', {
                            title: 'Estimation Success',
                            variant: 'success',
                            appendToast: true
                        });
                    })
                    .catch(ex => {
                        var currentErrors = this.handleAxiosException(ex);
                        this.showSpinner = false;
                        this.showErrorsToast(currentErrors);
                    });
            },

            startOverAgain: function () {

                this.estimatedDurationHours = 0;
                this.estimatedDurationMinutes = 0;
                this.serviceTypeId = null;
                this.serviceDelayId = null;
                this.quoteReceived = false;
                this.showAlertPanel = false;
                this.messageToDisplay = 0;

                if (this.$refs.serviceTypeValidationProvider) this.$refs.serviceTypeValidationProvider.reset();
                if (this.$refs.serviceDelayValidationProvider) this.$refs.serviceDelayValidationProvider.reset();
                
            }
        }, // methods

        mounted: function () {
            this.loadServiceTypes();
        }

    } // export default
</script>

<style scoped>
    #estimatorComponent {
        background-color: white;
    }
    .rightCol {
        color: #fff;
    }
    #header {
        background: #253746 !important;
        color: #FFFFFF !important;
    }
    b-link {
        color: #000 !important;
    }
    .contact {
        font-size: 20px;
    }
    .navbar-brand {
        margin-top: 5px;
    }
    h4 {
        font-weight: bold;
        margin: 12px 0px 0px 00px !important;
        font-family: "Questrial", sans-serif;
        font-size: 28px;
    }
    .result-div {
        border: 1px solid #bbb;
        padding: 10px 10px 0 10px;
        margin: 20px 0 0 0;
    }
</style>